import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import { useContext } from './useFormContext';
import useTargets from './useTargets';
import { UpdateValidationState } from './useValidationState';

const isValidTargetSelected = (target: string, targets: string[]) => !!target && targets.includes(target);

const TargetSelect: FC<{ vendorCurrency: string; updateValidationState: UpdateValidationState }> = ({
  vendorCurrency,
  updateValidationState,
}) => {
  const { locales } = useContext();
  const targets = useTargets(vendorCurrency);
  const [selectedTarget, setSelected] = useState(targets[0]);

  const updateTargetValidationState = (target: string) => {
    updateValidationState({ field: 'target', isValid: isValidTargetSelected(target, targets) });
  };

  const select = (target: string) => {
    setSelected(target);
    updateTargetValidationState(target);
  };

  const updateSelectedState = () => {
    if (!isValidTargetSelected(selectedTarget, targets)) {
      select(targets[0]);
    } else {
      updateTargetValidationState(selectedTarget);
    }
  };

  useEffect(() => {
    updateSelectedState();
  }, [targets.join('---')]);

  return (
    <div className="rs-column-small-12">
      <p>
        <label htmlFor="target">{`${locales.target_label}:`}</label>
        <select name="target" id="target" onChange={(v) => select(v.target.value)} value={selectedTarget}>
          {targets.map((t) => (
            <option value={t} key={t}>
              {t}
            </option>
          ))}
        </select>
      </p>
      <p className="rs-text-size_small alert">{locales.warning}</p>
    </div>
  );
};

export default TargetSelect;
